export default __webpack_public_path__ + "static/pexels-stephanie-ho-994164_-2beaabe65518b3725c63117d4ec43845.jpg";